import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { VisitService, UtilitiesService } from '@core/services';
import { RouteEnum } from '@features/contact-us/route-enum';
import { RewardService } from '@app/features/rewards/services/reward.service';
import { LoyaltyMode } from '../redux/stores';
import { environment } from '@environments/environment';
import { Constants } from '@core/constants/core.constants';

@Injectable()
export class VisitsGuard implements CanActivate {

  constructor(private _visitService: VisitService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
    if (environment.LOYALTY_MODE == LoyaltyMode.Points) {
      if (this._visitService.getLocationEntity()) {
        return true;
      } else {
        this.router.navigate([RouteEnum.LOCATIONS], { queryParams:
           UtilitiesService.generateQueryParams([Constants.RETURN_URL], ['visits/add'])});
        return false;
      }
    } else {
      return this.enforceVisits(state);
    }
  }
  private enforceVisits(state: RouterStateSnapshot) {
    if (this._visitService.canAddVisit()) {
      if (this._visitService.getLocationEntity()) {
        return true;
      } else {
        this.router.navigate([RouteEnum.LOCATIONS], {queryParams: 
          UtilitiesService.generateQueryParams([Constants.RETURN_URL], ['visits/add']) });
        return false;
      }
    } else {
      if (state.url && state.url === RouteEnum.VISITEXIST.toString() ) {
        return true;
      }
      this.router.navigateByUrl(RouteEnum.VISITEXIST);
      return true;
    }
  }

}
